import { Injectable } from '@angular/core';
import { BotService } from './bot.service';
import { EndBotOptions, EndbotService } from '@shared-angular/services/endbot.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { LanguageService } from '@shared-angular/services/language.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { FileAccessService } from '@shared-angular/services/file-access.service';

@Injectable({ providedIn: 'root' })
export class HelperManagerAdminService {
  constructor(
    private toastr: ToastrService,
    private endBotService: EndbotService,
    private botService: BotService,
    private botIdService: BotidService,
    private fileAccessService: FileAccessService,
    private languageService: LanguageService
  ) { }

  public closeWindow() {
    try {
      let currentWindow = window;
      let depth = 0;
      // Iterativ zum obersten schließbaren Fenster navigieren
      while (currentWindow !== currentWindow.parent) {
        depth++;
        if (depth > 10) { // Sicherheitsgrenze für unendliche Loops
          console.error("Zu viele Parent-Ebenen gefunden. Abbruch.");
          return;
        }
        //@ts-expect-error
        currentWindow = currentWindow.parent;
      }
      // Versuchen, das Fenster zu schließen
      currentWindow.close();
    } catch (error) {
      console.error("Fehler beim Schließen des Fensters:", error);
    }
  }

  public extractJavaScriptCode(input: string): string {
    const regex = /```(?:javascript|js)?\s*([\s\S]*?)\s*```/;
    const match = input.match(regex);
    if (match?.[1]) {
      const code = match[1].trim();
      return code;
    } else {
      return "";
    }
  }


  public copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastr.success("GENERAL", $localize`:@@clipboard-copy-success:Text kopiert`);
    }).catch((_error: unknown) => {
      this.toastr.error("ERROR", $localize`:@@clipboard-copy-error:Text konnte nicht kopiert werden.`);
    });
  }

  public timeToSeconds(hours: number, minutes: number, seconds: number): number {
    return seconds += minutes * 60 + hours * 3600;
  }



  public endBot(opts: Partial<EndBotOptions> = {}) {
    opts.autoRedirectSeconds ??= -1;
    opts.message ??= "Bot wurde beendet";
    opts.title ??= "Bot beendet";
    this.endBotService.endBot(this.botIdService.getBotId(), opts as EndBotOptions);
  }

  public async addStat(stat: string) {
    return await this.botService.addStat(this.botIdService.getBotId(), stat);
  }

  public getImageURlFromSkill(skillId: string): string {
    return this.fileAccessService.getFileUrl(this.botIdService.getBotId(), skillId);
  }

  public currentLanguage(): string {
    return this.languageService.getLanguage();
  }

}
